import { render } from "./ServicesDesktop.vue?vue&type=template&id=2be18ddd&scoped=true"
import script from "./ServicesDesktop.vue?vue&type=script&lang=js"
export * from "./ServicesDesktop.vue?vue&type=script&lang=js"

import "./ServicesDesktop.vue?vue&type=style&index=0&id=2be18ddd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be18ddd"]])

export default __exports__